import localizationKeys from "../../i18n/localizationKeys";


export const GROUP_PROMPTS = {
  SAVE: {
    title: localizationKeys.ChannelGroupPromptSaveTitle,
    message: localizationKeys.ChannelGroupPromptSaveSubtitle,
    okText: localizationKeys.ChannelGroupPromptSaveOkButton,
    cancelText: localizationKeys.ChannelGroupPromptSaveCancelButton,
  },
  CANCEL: {
    title: localizationKeys.ChannelGroupPromptCancelTitle,
    message: localizationKeys.ChannelGroupPromptCancelSubtitle,
    okText: localizationKeys.ChannelGroupPromptCancelOkButton,
    cancelText: localizationKeys.ChannelGroupPromptCancelCancelButton,
  },
  DELETE: {
    title: localizationKeys.ChannelGroupPromptDeleteTitle,
    message: localizationKeys.ChannelGroupPromptDeleteSubtitle,
    okText: localizationKeys.ChannelGroupPromptDeleteOkButton,
    cancelText: localizationKeys.CancelButtonText,
  },
  LEAVE: {
    title: localizationKeys.ChannelGroupPromptLeaveTitle,
    message: localizationKeys.ChannelGroupPromptLeaveSubtitle,
    okText: localizationKeys.ChannelGroupPromptLeaveOkButton,
    cancelText: localizationKeys.ChannelGroupPromptLeaveCancelButton,
  },
};
